import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DBDef_FHIRQuery } from '@app/fhir-shared';
import { createWorkHubManager } from '@app/styles';
import { ModuleFE_FHIRQuery } from '../../../_entity.js';
import { Renderer_FHIRQueryHeader } from './renderers/Renderer_FHIRQueryHeader/Renderer_FHIRQueryHeader.js';
import { Editor_FHIRQuery } from '../../Page_FHIRManager/Editor_FHIRQuery/Editor_FHIRQuery.js';
import { newFHIRQueryTemplate } from '../../../_entity/fhir-query/consts.js';
import './Manager_FHIRQuery.scss';
import { LL_V_L } from '@nu-art/thunderstorm-frontend/index';
const Editor_FHIRQuery_Wrapper = (props) => _jsxs(LL_V_L, { className: 'manager-fhir-query', children: [_jsx(Renderer_FHIRQueryHeader, { workHubItem: props.workHubItem, renderArgs: props.renderArgs }), _jsx(Editor_FHIRQuery, { editable: props.editable, editMode: props.renderArgs.editMode, hideHeader: true })] });
export const Manager_FHIRQuery = createWorkHubManager({
    module: ModuleFE_FHIRQuery,
    dbDef: DBDef_FHIRQuery,
    defaultItem: () => newFHIRQueryTemplate(),
    labelResolver: (item) => item.label ?? 'New FHIR Query',
    EditorComponent: Editor_FHIRQuery_Wrapper,
});
//# sourceMappingURL=Manager_FHIRQuery.js.map